export default "__VITE_ASSET__BPGd7x74__"